module.exports = __webpack_public_path__ + "img/levelup_avatar_default.0b057324.svg";